import React from "react"
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import Tooltip from '@mui/material/Tooltip';
import Grid from "@mui/material/Grid2";
import { handleKeyPress, handlePostCodeChange } from "./helpers";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { ui, temp, api } from "../../../../../../../../../interfaces/interfaces";
import useNato from "../../../../../../../../../hooks/useNato";
import { AddressUtils } from "@utils/address";
import { useAppSelector } from "@store/hooks";
import { inputComponentLogger } from "@utils/general";

type Props = {
    inputRef: any;
}

const name = "PostCodeInput"

const PostCodeInput: React.FC<Props> = ({ inputRef }) => {
    const problemInputPostcode = useAppSelector(({ ui }) => ui.ProblemInputPostcode)
    const problemActiveSearch = useAppSelector(({ temp }) => temp.ProblemAddressActiveSearch)

    const nato = useNato("Postcode", problemInputPostcode)

    useDebugInformation("PostCodeInput", { problemActiveSearch, problemInputPostcode, inputRef, nato })

    return (
        (<Grid
            size={{
                xs: 12,
                sm: 6
            }}>
            <Tooltip title={nato} sx={{ maxWidth: "none" }}>
                <TextField
                    id="input-post-code"
                    name="ProblemInputPostcode"
                    value={problemInputPostcode}
                    onChange={handlePostCodeChange}
                    label="Postcode"
                    onKeyPress={handleKeyPress}
                    onBlur={(e) => inputComponentLogger(name, e.target.value)}
                    fullWidth
                    autoComplete='off'
                    inputRef={inputRef}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton size="small" disabled={(!problemActiveSearch) ? true : false} color="info" onClick={() => AddressUtils.searchAddressesProblem({ temp, ui, api })}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },

                        inputLabel: { shrink: true }
                    }} />
            </Tooltip>
        </Grid >)
    );
}

PostCodeInput.displayName = name

export default React.memo(PostCodeInput)